import { Button, Input } from '@attentive-platform/stem-ui';

const BearerSearchSection = ({ companyId, setCompanyId, userEmail, setUserEmail, onSearch, searchLoading }) => (
  <div className='flex flex-wrap gap-4 items-end mb-6'>
    <div className='flex-1 min-w-[200px]'>
      <label className='text-sm font-medium text-gray-700 block mb-1'>Company ID</label>
      <Input
        value={companyId}
        className='w-full'
        placeholder='Enter company ID'
        onChange={e => setCompanyId(e.target.value)}
      />
    </div>
    <div className='flex-1 min-w-[200px]'>
      <label className='text-sm font-medium text-gray-700 block mb-1'>User email</label>
      <Input
        value={userEmail}
        className='w-full'
        placeholder='Enter user email address'
        onChange={e => setUserEmail(e.target.value)}
      />
    </div>
    <Button color='primary' onClick={onSearch} loading={searchLoading}>
      Search
    </Button>
  </div>
);

export default BearerSearchSection;
